import React from 'react';

import { Organization, WebSite } from 'ha/components/LinkedData';
import { useIntl } from 'ha/i18n';
import { ContentfulSupportedLangs } from 'ha/modules/Hermes/constants';

import { TopCities as list } from '../constants';
import { Blog } from '../types';
import Hero from './Hero';
import HomeHelmet from './HomeHelmet';
import TopCities from '../containers/TopCities';
import InfoSection from './InfoSection';
import FeaturedCities from '../containers/FeaturedCities';
import { ApartmentsAndRooms } from './FeaturedCities/ApartmentsAndRooms';
import Separator from './Separator';
import BlogCards from './BlogCards';
import { FeaturedCountries } from './FeaturedCountries/FeaturedCountries';

interface Props {
  promotedContentTitle: string;
  promotedContent: Blog[];
}

const HomeLayout: React.FC<Props> = ({
  promotedContentTitle,
  promotedContent,
}) => {
  const { lang } = useIntl();

  return (
    <div>
      <HomeHelmet />
      <Organization />
      <WebSite />
      <Hero />
      <TopCities list={list} />
      <Separator rotate />
      <InfoSection />
      <FeaturedCities />
      <Separator />
      {ContentfulSupportedLangs.includes(lang) ? (
        <FeaturedCountries />
      ) : (
        <ApartmentsAndRooms />
      )}
      {promotedContent.length > 0 && (
        <React.Fragment>
          <Separator rotate />
          <BlogCards title={promotedContentTitle} blogs={promotedContent} />
        </React.Fragment>
      )}
    </div>
  );
};

export default HomeLayout;
